module.exports = __webpack_public_path__ + "img/video-banner-reverse.82447c91.svg";